module.exports = __webpack_public_path__ + "img/net5_logo.8bc57452.jpg";